// extracted by mini-css-extract-plugin
export default {"h1":"H1_h1__7mkGg"};